import { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import ProductsPage from "../pages/products/page";
import CartPage from "../pages/cart/page";
import SupportPage from "../pages/support/page";
import OrderPage from "../pages/order/page";
import OrderHistoryPage from "../pages/order-history/page";
import PointPurchasePage from "../pages/point-purchase/page";
import MyPointsPage from "../pages/my-points/page";
import ErpGuidePage from "../pages/erp-guide/page";
import ErpCallbackPage from "../pages/erp-callback/page";
import YaksonkongPage from "../pages/products/yaksonkong/page";
import SpirilinaPage from "../pages/products/spirulina/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "/products/yaksonkong",
    element: <YaksonkongPage />,
  },
  {
    path: "/products/spirulina",
    element: <SpirilinaPage />,
  },
  {
    path: "/cart",
    element: <CartPage />,
  },
  {
    path: "/order",
    element: <OrderPage />,
  },
  {
    path: "/order-history",
    element: <OrderHistoryPage />,
  },
  {
    path: "/point-purchase",
    element: <PointPurchasePage />,
  },
  {
    path: "/my-points",
    element: <MyPointsPage />,
  },
  {
    path: "/support",
    element: <SupportPage />,
  },
  {
    path: "/erp-guide",
    element: <ErpGuidePage />,
  },
  {
    path: "/erp-callback",
    element: <ErpCallbackPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;